import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'ToolTip',
  props: {
    tooltip: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "py-1 px-2",
    style: _normalizeStyle({
      position: 'absolute',
      top: `${props.tooltip.y}px`,
      left: `${props.tooltip.x}px`,
      background: 'rgb(0,0,0,0.7)',
      border: '1px solid rgb(0,0,0,0.6)',
      color: 'white',
      borderRadius: '8px',
      pointerEvents: 'none'
    })
  }, [
    _createElementVNode("div", null, [
      _createElementVNode("div", null, [
        _createElementVNode("strong", null, _toDisplayString(props.tooltip.time), 1)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("strong", null, "▫️" + _toDisplayString(props.tooltip.value), 1)
      ])
    ])
  ], 4))
}
}

})